import React, { createContext } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';
import { useAppCtx } from './app-ctx';
import { useNavigate, useLocation, BrowserRouter } from 'react-router-dom';
import { Routes, Route, Router  } from 'react-router-dom';
import ResortLoader from './resort-loader';
import Gallery1 from './galery1';

import ResortDetailsFull from './resort-details-full';
import ResortDetailsFullTabbed from './resort-details-full-tabbed-v1';


const ResortPageManager = ({resortId}) => {
    const { t } = useTranslation();
    const [galleryMode, setGalleryMode] = React.useState(window.location.hash === '#gallery');

    const showGallery = window.location.hash === '#gallery';

    const navigate = useNavigate();
    const location = useLocation();

    //console.log('ResortPageLoader(): galleryMode=' + galleryMode, 
    //        'showGallery=' + showGallery, 'window.location.hash=\'' + window.location.hash+'\'');

    React.useEffect(() => {
        setGalleryMode(window.location.hash === '#gallery');
        
        //console.log('ResortPageLoader(): galleryMode=' + galleryMode, 
    //        'showGallery=' + showGallery, 'window.location.hash=\'' + window.location.hash+'\'');

    }, [location]);


    const openGallery = () => {
        // Add #gallery to current URL
        navigate(`${location.pathname}#gallery`, {
          //state: { resortName, images }, // Pass data via state
          //state: { resortName:theResort.name, imageUrls:theResort.imageUrlsAll,onClose:handleGaleryClose }, // Pass data via state
          state: {},
          replace: false // Replace current history entry
        });
      };
    
    const closeGallery = () => {
        // Remove hash from URL
        navigate(-1); // Or navigate(location.pathname, { replace: true })
    };

    handeMoreImagesClick = () => {
        //setGalleryMode(true);
        openGallery();
    }
    handleGaleryClose = () => {
        //setGalleryMode(false);
        closeGallery();
    }

    return (
        <ResortLoader resortId={resortId}>
            {(theResort) => {
            if (!theResort) {
                return <div className="loading">{t('Loading ...')}</div>;
            }

            if (theResort.name) {
                document.title = `${theResort.name} - ${window.location.hostname}`;
            }

            return (
                (!galleryMode)
                    ? <ResortDetailsFullTabbed theResort={theResort} moreImagesClick={handeMoreImagesClick} />
                    : <Gallery1 resortName={theResort.name} imageUrls={theResort.imageUrlsAll} onClose={handleGaleryClose} />
                );
            }}
        </ResortLoader>
    );
}

const ResortPage = ({resortId}) => {
    console.log(`ResortPage().Entry: resortId=${resortId}`);
    return (
        <BrowserRouter>
            <ResortPageManager resortId={resortId} />
        </BrowserRouter>
    );
}

export default ResortPage;
